import React, { FC } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import TableTab from "../components/tabs/table-tab";
import { DEF_PG_SIZE_LIST_W_ADD } from "../constants/maximum-page-size";
import { EMAIL_ACCOUNTS } from "../constants/menu-types";
import { TranslationKeys } from "../contexts/TranslationKeys";
import { useLocale } from "../contexts/localeContext";
import { TableContextProvider } from "../contexts/table/TableContextProvider";
import plusIcon from "../images/Plus.svg";
import { Category } from "../models/Category";
import EmailAccountColumns from "../models/ColumnDefinitions/EmailAccountColumns";
import EmailAccountsSearch from "../models/search/EmailAccountsSearch";
import { DeleteEntityResult } from "../models/services/DeleteEntityResult";
import {deleteEmailAccount, getAllEmailAccounts} from "../services/emailAccountService";
import { getActiveInactiveTableLegendItems } from "../models/TableLegend";

interface Props {
    setBusy: (isBusy: boolean) => void;
    categories: Category[];
    setCategories: (category: Category[]) => void;
}

const EmailAccountsTab: FC<Props> = ({
    setBusy,
    categories,
    setCategories,
}) => {
    const { translate } = useLocale();
    const title = translate.byKey(TranslationKeys.emailAccounts);
    const allItemsPath = "/access-control/configuration/accounts";
    const itemPath = "/access-control/configuration/account-setup/";

    const onDelete = (id: string): Promise<DeleteEntityResult> => {
        setBusy(true);
        return new Promise((resolve, reject) => {
            deleteEmailAccount(id).then(
                (deleteResult) => {
                    resolve(deleteResult);
                    const newCatergories: Category[] = categories.map(
                        (category) => {
                            return category.id === 1
                                ? {
                                      ...category,
                                      count: (category?.count ?? 1) - 1,
                                  }
                                : category;
                        }
                    );
                    setCategories(newCatergories);
                    setBusy(false);
                },
                (deleteResult) => {
                    reject(deleteResult);
                    setBusy(false);
                }
            );
        });
    };

    // --> start context
    // user preference items
    const userLoginId = useSelector((state: any) => state.userInfo.id);
    const currentMenuDetail = EMAIL_ACCOUNTS;
    const initialiseUserPreferences = (setDetails: (userLoginId, currentMenuDetail) => void) => {
        setDetails(userLoginId, currentMenuDetail);
    };
    // <-- end context

    return (
        <TableContextProvider
            dataMethod={(listParameters) => getAllEmailAccounts(translate, listParameters)}
            initialiser={(setDetails) => initialiseUserPreferences(setDetails)}
            tableDescriptor={EmailAccountColumns}
            searchDescriptor={EmailAccountsSearch}
            useTable
            usePagination
            useFilter
            useSearch
            useSort
            legendItems={getActiveInactiveTableLegendItems(translate)}
            maxPageSize={DEF_PG_SIZE_LIST_W_ADD}
            deleteMethod={onDelete}
        >
            <TableTab
                title={title}
                selectRows={false}
                rowPath={itemPath}
                cyName="emailAccounts"
            />
            <div className="flex flex-col flex-grow overflow-y-hidden mb-viewport">
                <div className="flex flex-row justify-end button-cluster">
                    <Link
                        to={{
                            pathname:
                            itemPath,
                        }}
                    >
                        <button
                            className="flex rounded-lg bg-lime text-white p-2 shadow-lg"
                            id="addEmailAccountButton"
                        >
                            <img
                                src={plusIcon}
                                className="px-2 w-8 py-1"
                                alt="Add Button"
                            />
                            <span className="mr-2">
                                {translate.byKey(TranslationKeys.add)}
                            </span>
                        </button>
                    </Link>
                </div>
            </div>
        </TableContextProvider>
    );
};

export default EmailAccountsTab;
